import { GoogleOAuthProvider } from "@react-oauth/google";

/**
 * Mounts GoogleOAuthProvider (and thus gsi/client) only where Google login is used.
 * Do not wrap _app — that loads the script on every page and hurts SEO audits.
 */
export default function LazyGoogleOAuthProvider({ children }) {
  return (
    <GoogleOAuthProvider clientId={process.env.GOOGLE_CLIENT_ID}>
      {children}
    </GoogleOAuthProvider>
  );
}
